// apps/client/src/assets/builders/rod.ts — port of look-demo doll.ts giveRod(), rebuilt in world units with a reel
import * as THREE from 'three';
import { toyMaterial } from '../../characters/doll';
import type { CodeBuilder } from '../service';
export const builder: CodeBuilder = {
  id: 'rod',
  build() {
    const g = new THREE.Group(); g.name = 'rod';
    const pole = new THREE.Mesh(new THREE.CylinderGeometry(0.014, 0.024, 1.4, 8), toyMaterial('#8A6A4F'));
    pole.position.y = 0.7;
    const grip = new THREE.Mesh(new THREE.CylinderGeometry(0.03, 0.03, 0.22, 10), toyMaterial('#5E4733'));
    grip.position.y = 0.1;
    const reel = new THREE.Mesh(new THREE.CylinderGeometry(0.05, 0.05, 0.04, 14).rotateZ(Math.PI / 2), toyMaterial('#C9A27E'));
    reel.position.set(0.04, 0.26, 0);
    const tip = new THREE.Object3D(); tip.position.y = 1.4;
    g.add(pole, grip, reel, tip);
    g.userData.tip = tip;
    return g;
  },
};
